module.exports = __webpack_public_path__ + "static/img/quanmin_qmwallet1.c940614b.png";